<template>
  <div class="lxwm">
    <div class="banner">
      <img class=" banner_img" src="../../static/img/lianxiwe_banner.png" alt="">
    </div>
    <div class="content">
      <div class="content_hz">
        <ul class="cont_wz">
          <li><img src="../../static/img/lxwe_add1.png" alt=""></li>
          <li class="lxdz">
            <img src="../../static/img/lxwe_add1_bd.png" alt="">
            <div class="lxdz_nr" @click="baidu(116.442208,39.922129)">
              <p>北京飞猪科技有限公司（北京）</p>
              <p>北京市朝阳区朝阳门南大街16号楼</p>
              <p>400-665-0265</p>
            </div>
          </li>
          <li class="lxdz">
            <img src="../../static/img/lxwe_add2_bd.png" alt="">
            <div class="lxdz_nr" @click="baidu(121.628239,31.259323)">
              <p>北京飞猪科技有限公司（上海）</p>
              <p>上海市浦东新区宁桥路909号</p>
              <p>400-665-0265</p>
            </div>
          </li>
          <li><img src="../../static/img/lxwe_add2.png" alt=""></li>
          <li><img src="../../static/img/lxwe_add3.png" alt=""></li>
          <li class="lxdz">
            <img src="../../static/img/lxwe_add1_bd.png" alt="">
            <div class="lxdz_nr" @click="baidu(119.182886,36.657241)">
              <p>北京飞猪科技有限公司（山东）</p>
              <p>山东省潍坊市坊子区凤凰街168号</p>
              <p>400-665-0265</p>
            </div>
          </li>
          <li class="lxdz">
            <img src="../../static/img/lxwe_add2_bd.png" alt="">
            <div class="lxdz_nr" @click="baidu(104.061426,30.556228)">
              <p>北京飞猪科技有限公司（成都）</p>
              <p>成都高新区益州大道中段722号</p>
              <p>400-665-0265</p>
            </div>
          </li>
          <li><img src="../../static/img/lxwe_add4.png" alt=""></li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'lxwm',
  data () {
    return {
    }
  },
  methods: {
    baidu (lng, lat) {
      sessionStorage.setItem('bddt', 1)
      this.$router.push({path: '/Lxdt', query: {x: lng, y: lat}})
    },
    // lxwm?page=6
    isMobile() {
        let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
        return flag;
    }
  },
   mounted () {
    if(this.isMobile()) {
          this.$router.push({ path: "/contact" });
        } else {
          this.$router.push({ path: "/lxwm?page=6" });
        }
  }
}
</script>

<style lang="scss" scoped>
.content {
    width: 100%;
    max-width: 19.2rem;
    background-color: #024ea2;
    margin: 0 auto;
    position: relative;
    height: 14.02rem;
    .content_hz {
        position: absolute;
        top: -0.45rem;
        left: 50%;
        transform: translateX(-50%);
        max-width: 13.90rem;
        background-color: #f2f2f2;
        margin: 0 auto;
        .cont_wz {
            width: 12rem;
            display: flex;
            flex-wrap: wrap;
            margin: 0 auto;
            box-sizing: border-box;
            padding: .6rem;
            li {
                width: 5.32rem;
                img {
                    width: 100%;
                    height: 100%;
                }
            }
            .lxdz {
                position: relative;
                .lxdz_nr {
                    margin: 0 auto;
                    position: absolute;
                    top: .3rem;
                    left: .5rem;
                    p {
                        font-size: .3rem;
                        padding: .2rem 0;
                    }
                }
            }
            .lxdz_nr:hover p {
                color: red;
                cursor: pointer;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/Lxwm.vue